import { ColorEnum } from '@/constants/color'
import { circleCenter, radioIconSize } from '@/features/ui/inputs/components/RadioButton/constants'
import { FC } from 'react'
import Svg, { Circle, SvgProps } from 'react-native-svg'

const CheckedRadioIcon: FC<SvgProps> = (props) => {
    return (
        <Svg fill="currentColor" stroke="currentColor" {...radioIconSize} {...props}>
            <Circle {...circleCenter} r={9.5} />
            <Circle {...circleCenter} r={5} fill={ColorEnum.WHITE} />
        </Svg>
    )
}

export default CheckedRadioIcon
